export const APP_NAME = 'Kutoa Solutions'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = ''
export const OTP_URL_KEY = '/otp'
